<template>
  <div class="ak-mobile-viewport align-center">
    <img :src="image" class="ak-mobile-viewport__device" />
    <div class="ak-mobile-viewport__viewport">
      <template v-if="type === 'text'">
        <ak-mobile-view-port-text :from="from">
          <slot />
        </ak-mobile-view-port-text>
      </template>

      <template v-else>
        <slot />
      </template>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import Text from './Text.vue'

export default defineComponent({
  /**
   * @type {String}
   * @description This is the name of the component this will also
   * be the tag name of the component to use in templates
   * @example
   * <ak-mobile-view-port />
   */
  name: 'AkMobileViewPort',

  /**
   * @type {Object}
   * @description A collection of components that this component
   * is dependant on.
   */
  components: {
    [Text.name]: Text,
  },

  /**
   * @type {Object}
   * @description A collection of properties that may be passed into
   * the component these will be bound to the component instance and
   * may be access in the template and component methods.
   */
  props: {
    /**
     * @type {String}
     * @description The image background to use for the phone UI
     */
    image: {
      type: String,
      default:
        'https://res.cloudinary.com/big-top/image/upload/v1532686024/system-v2/devices/iphonex-mockup-grey.png',
    },

    /**
     * @type {String}
     * @description The type of view to display
     */
    type: {
      validator: (v) => ['blank', 'text'].indexOf(v) !== -1,
      type: String,
      default: 'blank',
    },

    /**
     * @type {String}
     * @description The default from number to display in the ui
     * for the text view
     */
    from: {
      type: String,
      default: undefined,
    },
  },
})
</script>

<style lang="scss">
@import '../../scss/_settings.scss';

.ak-mobile-viewport {
  position: relative;
  display: block;
  max-width: 400px;

  &__device {
    width: 100%;
    height: auto;
  }

  &__viewport {
    position: absolute;
    top: 10.75642%;
    right: 15.625%;
    bottom: 9.36849%;
    left: 15.625%;
    width: 68.75%;
    height: 79.87509%;
    background-color: #fff;
    border-radius: 0 0 28px 28px;
  }
}
</style>
